import 'css-chunksrc/client/scenes/changePassword/error/styles.scss';export default {
  "error": "_error_1kben_1",
  "text": "_text_1kben_5"
};